// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItemAvatarAndContent-base__RJZbw{display:flex;flex-direction:row;gap:var(--size-3);align-items:center;width:var(--size-full);min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ListItemAvatarAndContent-base__RJZbw"
};
export default ___CSS_LOADER_EXPORT___;
